import { datadogRum } from '@datadog/browser-rum'
import config from './runtime'

/**
 * Initialize Datadog RUM monitoring
 */
export const initializeDatadog = () => {
    const rumAppId = '43f0d339-f629-4e00-b461-ffca38555183'
    const rumClientToken = 'pubd62169a1180d6ca64ef53a1b72cac572'
    const ddSite = 'datadoghq.com'
    datadogRum.init({
        applicationId: rumAppId,
        clientToken: rumClientToken,
        site: ddSite,
        service: 'field-tool-web',
        env: 'prod',

        // Specify a version number to identify the deployed version of your application in Datadog
        version: config.BUILD_VERSION ?? '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
    })

    // Ensure datadog only run on Production Environment
    if (config.ENVIRONMENT_URL === 'app.purplewave.heavyworth.net') {
        datadogRum.startSessionReplayRecording()
    }
}
